import * as Yup from 'yup';

export const PHONE_REGIONS = [
  { value: 'CN', label: '中国大陆 +86', callingCode: '+86', nationalLength: 11 },
  { value: 'HK', label: '中国香港 +852', callingCode: '+852', nationalLength: 8 },
  { value: 'MO', label: '中国澳门 +853', callingCode: '+853', nationalLength: 8 },
];

export const phoneRegion = {
  name: 'phone_region',
  validator: Yup.string()
    .oneOf(PHONE_REGIONS.map(({ value }) => value))
    .required(),
  initialValue: 'CN',
};

export const getPhoneRegion = (region) => PHONE_REGIONS.find(({ value }) => value === region) || PHONE_REGIONS[0];

export const toApiPhone = (region, nationalNumber) => {
  const value = (nationalNumber || '').replace(/[\s()-]/g, '');
  const selectedRegion = getPhoneRegion(region);
  return selectedRegion.value === 'CN' ? value : `${selectedRegion.callingCode}${value}`;
};

export const phone = {
  name: 'phone',
  placeholder: '请输入手机号',
  validator: Yup.string()
    .required('手机号不可为空')
    .test('valid-phone', function (value) {
      if (!value) {
        return true;
      }

      const region = getPhoneRegion(this.parent[phoneRegion.name]);
      const normalized = value.replace(/[\s()-]/g, '');
      const isValid = region.value === 'CN'
        ? /^1\d{10}$/.test(normalized)
        : new RegExp(`^\\d{${region.nationalLength}}$`).test(normalized);

      return isValid || this.createError({
        message: `${region.label.split(' ')[0]}手机号格式不正确`,
      });
    }),
  initialValue: '',
};

export const identifier = {
  name: 'identifier',
  placeholder: '请输入邮箱或手机号',
  validator: Yup.string().required('邮箱或手机号不能为空'),
  initialValue: '',
};

export const verifyCode = {
  name: 'code',
  placeholder: '6位验证码',
  validator: Yup.string()
    .length(6, ({ length }) => `请输入${length}位验证码`)
    .required('验证码不可为空'),
  initialValue: '',
  sendVerifyCodeBtnText: '发送验证码',
  limitSeconds: 60000,
  countDownFormatter: (ms) => `${Math.round(ms / 1000)}s`,
};

export const password = {
  name: 'password',
  placeholder: '请输入密码',
  validator: Yup.string().required('密码不可为空'),
  initialValue: '',
};

export const newPassword = {
  ...password,
  name: 'new_password',
  validator: password.validator.min(8, '密码最少为8个字符'),
};

export const confirmPassword = {
  name: 'confirm_password',
  placeholder: '请再次输入密码',
  validator: Yup.string().oneOf([Yup.ref('new_password')], '两次密码输入不相同'),
  initialValue: '',
};

export const email = {
  name: 'email',
  placeholder: '请输入邮箱',
  validator: Yup.string().email('请输入有效的邮箱').required('邮箱不可为空'),
  initialValue: '',
};

export const company = {
  name: 'company',
  placeholder: '请选择所在的公司',
  validator: Yup.string()
    .min(1, ({ min }) => `最少输入${min}个字符`)
    .max(100, ({ max }) => `最多输入${max}个字符`)
    .required('公司不能为空'),
  initialValue: '',
};

export const manualCompany = {
  name: 'manual_company',
  placeholder: '请填写所在的公司',
  validator: Yup.string()
    .min(1, ({ min }) => `最少输入${min}个字符`)
    .max(100, ({ max }) => `最多输入${max}个字符`)
    .required('公司不能为空'),
  initialValue: '',
}
